var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVoiceIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 35.632,
    height: 32.315,
    viewBox: "0 0 35.632 32.315",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35.632,
    height: 32.315,
    fill: "#0087ff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.12,0c11.017.024,17.66,10.849,13.009,19.992a1.456,1.456,0,0,0-.063,1.3c.507,1.367.975,2.75,1.441,4.132.347,1.028-.252,1.72-1.3,1.515-1.659-.324-3.313-.681-4.979-.968a2.782,2.782,0,0,0-1.254.147c-1.034.328-2.056.7-3.069,1.089a2.439,2.439,0,0,0-.912.551,13.784,13.784,0,0,1-16.416,3.1,1.815,1.815,0,0,0-1.047-.135c-1.687.3-3.364.659-5.047.985-1.111.215-1.718-.467-1.357-1.528.493-1.447,1.024-2.88,1.5-4.333a1.294,1.294,0,0,0-.065-.891A13.793,13.793,0,0,1,10.732,5.106a1.937,1.937,0,0,0,.9-.563A13.349,13.349,0,0,1,21.12,0M2.636,29.337c1.434-.282,2.729-.517,4.014-.8a2.02,2.02,0,0,1,1.52.244A11.014,11.014,0,0,0,13.276,30.2a11.675,11.675,0,1,0-9.555-5.724,1.583,1.583,0,0,1,.112,1.449c-.4,1.082-.768,2.179-1.2,3.409M32.992,24.56c-.426-1.226-.785-2.327-1.2-3.408a1.594,1.594,0,0,1,.148-1.508,11.077,11.077,0,0,0,1.588-5.412A11.676,11.676,0,0,0,19.274,2.384a10.847,10.847,0,0,0-4.805,2.378,13.649,13.649,0,0,1,11.143,6.829c2.449,4.158,2.507,8.506.536,13.037a9.565,9.565,0,0,0,1.132-.532,2.29,2.29,0,0,1,1.913-.3c1.211.29,2.443.495,3.8.761",
    transform: "translate(0)",
    fill: "#0087ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.733,103.831c0-1.157-.006-2.314,0-3.47.006-.756.4-1.229,1.008-1.244.634-.016,1.075.477,1.079,1.262q.015,3.47,0,6.941c0,.811-.407,1.271-1.062,1.266s-1.022-.457-1.027-1.284c-.007-1.157,0-2.313,0-3.47",
    transform: "translate(-53.997 -85.317)",
    fill: "#0087ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.01,110.384c0,.834.01,1.668,0,2.5a1.051,1.051,0,1,1-2.085.008q-.017-2.536,0-5.073a1.046,1.046,0,1,1,2.084-.008c.015.857,0,1.714,0,2.571",
    transform: "translate(-103.218 -91.826)",
    fill: "#0087ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.3,117.517c0,.51.022,1.021-.006,1.53a.943.943,0,0,1-.972.976.917.917,0,0,1-1.061-.876,31.064,31.064,0,0,1-.01-3.265,1.027,1.027,0,0,1,2.047.1c.021.509,0,1.02,0,1.53h0",
    transform: "translate(-78.515 -98.959)",
    fill: "#0087ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36,117.515c0,.487.018.975,0,1.462a1.038,1.038,0,0,1-2.075.043c-.03-1.02-.032-2.042,0-3.062a1.008,1.008,0,0,1,1.049-.99A1.019,1.019,0,0,1,36,115.984c.026.509.005,1.021.006,1.531",
    transform: "translate(-29.181 -98.961)",
    fill: "#0087ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.769,122.7a5.948,5.948,0,0,1-.123.952.927.927,0,0,1-1.056.7.937.937,0,0,1-.931-.935,12.435,12.435,0,0,1-.01-1.382,1.009,1.009,0,0,1,1.017-1.075A1.04,1.04,0,0,1,150.727,122c.022.228,0,.461,0,.691l.038,0",
    transform: "translate(-127.941 -104.114)",
    fill: "#0087ff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoiceIcon);
export default __webpack_public_path__ + "static/media/voice-icon.4158f64e497d5a45db4215db64cf301e.svg";
export { ForwardRef as ReactComponent };